import Linkify from 'linkify-react'

import { cn } from '~/utils/tailwind-utils'

export const FormattedText = ({
  text,
  className,
}: {
  text: string
  className?: string
}) => {
  return (
    <span className={cn('whitespace-pre-wrap break-words', className)}>
      <Linkify
        options={{
          defaultProtocol: 'https',
          attributes: {
            target: '_blank',
            rel: 'noopener noreferrer',
            class: 'underline',
          },
        }}
      >
        {text}
      </Linkify>
    </span>
  )
}
